import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges, OnDestroy, ViewChild } from '@angular/core';
import { Masks } from '@core/custom-validators/masks';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker, MatDatepickerInput, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Subscription } from 'rxjs';
import { Moment } from 'moment';

class CustomDateAdapter extends MomentDateAdapter {
  getDayOfWeekNames(style: 'long' | 'short' | 'narrow') {
    return ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'];
  }
}

export const MATERIAL_DATEPICKER_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'ds-custom-datepicker-transporte',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },

    { provide: MAT_DATE_FORMATS, useValue: MATERIAL_DATEPICKER_FORMATS },
  ],
})
export class DatepickerComponent implements OnInit, OnChanges, OnDestroy {

  @Input() placeholder: string = ''
  @Input() ngModel: any
  @Input() name: string = ''
  @Input() mask: string = ''
  @Input() id: string = ''
  @Input() label: string = ''
  private _value: any = null
  @Input()
  get value() {
    return this._value
  }
  set value(val: any) {
    this._value = this.formatDate(val)
  }
  @Input() todayAsMaxDate: any = ''
  @Input() readonly: boolean = false
  @Input() opcional: any
  @Input() required: boolean = false
  @Input() submitted: boolean = false
  @Input() disabled: boolean = false
  @Input() calendarIconLeft: boolean = false

  @Output() ngModelChangeValue = new EventEmitter<any>()

  @Input() validateInputEvent: EventEmitter<boolean> = new EventEmitter<boolean>()

  dateInputValue: any
  wasInputFocused: boolean = false
  wrongInput: boolean = false

  dateMask = {
    mask: Masks.data,
    guide: false,
    modelClean: true
  }

  touched = false
  private validateSubscription?: Subscription

  @ViewChild('picker') picker?: MatDatepicker<Moment>
  @ViewChild('pickerInput') pickerInput?: MatDatepickerInput<Moment>
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.submitted && changes.submitted.currentValue === false) {
      this.touched = false
      this.dateInputValue = null
      this.wrongInput = false
      this._value = null

      if (this.todayAsMaxDate) {
        this.todayAsMaxDate = new Date()
      }
      if (this.picker) {
        this.picker.select(null)
      }
      if (this.pickerInput) {
        this.pickerInput.value = null
      }
    }
  }

  constructor(
  ) { }

  ngOnInit() {
    if (this.todayAsMaxDate) {
      this.todayAsMaxDate = new Date()
    }

    this.validateInput()
  }

  validateInput() {
    this.validateSubscription = this.validateInputEvent.subscribe(() => {
      this.wasInputFocused = true
    })
  }

  ngOnDestroy(): void {
    this.validateSubscription?.unsubscribe()
  }

  emitDate(dateEvent: MatDatepickerInputEvent<Moment>) {
    let dateValue = null
    const value = dateEvent?.value
    if (value) {
      if (typeof value.format === 'function') {
        dateValue = value.format('DD/MM/YYYY')
      } else if (value instanceof Date) {
        dateValue = `${('0'+value.getDate()).slice(-2)}/${('0'+(value.getMonth()+1)).slice(-2)}/${value.getFullYear()}`
      } else {
        dateValue = value
      }
    } else {
      dateValue = null
    }
    this.ngModelChangeValue.emit(dateValue)
  }

  setInputValue(value: string) {
    this.dateInputValue = value ? value : null
    this.wrongInput = this.dateInputValue == null ? false : this.wrongInput
  }

  validateFormat(dateValue: Date) {
    this.wrongInput = !dateValue ? true : false
  }

  formatDate(val: any): any {
    if (!val) return null
    if (typeof val?.format === 'function') {
      return val.format('DD/MM/YYYY')
    } else if (val instanceof Date) {
      return `${('0'+val.getDate()).slice(-2)}/${('0'+(val.getMonth()+1)).slice(-2)}/${val.getFullYear()}`
    } else if (typeof val === 'string') {
      const match = val.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
      if (match) {
        return val
      } else {
        const parts = val.split(/[-T: ]/)
        if (parts.length >= 3) {
          return `${('0'+parts[2]).slice(-2)}/${('0'+parts[1]).slice(-2)}/${parts[0]}`
        } else {
          return val
        }
      }
    } else if (val?._d && val._d instanceof Date) {
      const d = val._d
      return `${('0'+d.getDate()).slice(-2)}/${('0'+(d.getMonth()+1)).slice(-2)}/${d.getFullYear()}`
    }
    return val
  }

}
